'use strict';
module.exports = function PKCEUtils ({navigatorShim, clientId, interactionRequiredErrors, ajaxPromise, logger} = {}) {
	if (!navigatorShim || !clientId || !interactionRequiredErrors || !ajaxPromise) {
		throw new Error('invalid-args');
	}
	let cachedChallenge;
	const createPKCEURL = ({code, state, requiredScopes, endpointUrl, redirectUri, optional = {}} = {}) => {
			if (!code || !state || !requiredScopes || !endpointUrl || !redirectUri) {
				throw new Error('invalid-args');
			}
			const requestParams = {
				code_challenge_method: 'S256',
				code_challenge: code,
				response_type: 'code',
				scope: requiredScopes,
				client_id: clientId,
				redirect_uri: redirectUri,
				state,
				nonce: state,
				response_mode: 'fragment'
			};
			if (optional?.login_hint) {
				requestParams.login_hint = optional.login_hint;
			}
			if (optional?.prompt) {
				requestParams.prompt = optional.prompt;
			}
			return navigatorShim.encodeUrlParams(endpointUrl + 'authorize', requestParams);
		},
		completePKCEFlow =  async ({pkceResponse = {}, state, verifier, endpointUrl, requiredScopes, redirectUri} = {}) => {
			if (!state || !verifier || !endpointUrl || !requiredScopes || !redirectUri) {
				throw new Error('invalid-args');
			}
			if (pkceResponse.error) {
				logger?.error(pkceResponse);
				if (interactionRequiredErrors.includes(pkceResponse.error)) { // MS-specific login required errors
					throw 'popup-auth-required';
				}
				throw 'not-authenticated';
			}
			if (!pkceResponse.code || pkceResponse.state !== state) {
				throw 'network-error';
			}
			const params = {
				'tenant': 'common', //MS-Specific
				'scope': requiredScopes, // MS-Specific
				'grant_type': 'authorization_code',
				'code': pkceResponse.code,
				'client_id': clientId,
				'redirect_uri': redirectUri,
				'code_verifier': verifier
			};
			return ajaxPromise.request({
				type: 'POST',
				url: endpointUrl + 'token',
				headers: {'Content-Type': 'application/x-www-form-urlencoded'},
				data: new URLSearchParams(params).toString()
			});
		},
		urlEncodeB64 = (buffer) => {
			const input = navigatorShim.bufferEncodeBase64(buffer),
				urlSafeChars = {'+': '-', '/': '_', '=': ''};
			return input.replace(/[+/=]/g, m => urlSafeChars[m]);
		},
		asyncCreateChallenge = async () => {
			const verifier = navigatorShim.uniqueString(32),
				codeBuffer = await navigatorShim.sha256Digest(verifier),
				code = urlEncodeB64(codeBuffer),
				state = navigatorShim.uniqueString(10);
			return {code, verifier, state};
		},
		createChallenge = () => {
			if (!cachedChallenge) {
				throw 'not-authenticated';
			}
			asyncCreateChallenge().then(c => cachedChallenge = c);
			return cachedChallenge;
		},
		ready = asyncCreateChallenge().then(c => cachedChallenge = c);
	Object.freeze(Object.assign(this, {createPKCEURL, completePKCEFlow, createChallenge, asyncCreateChallenge, ready}));
};
